import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserColonyGame from 'src/games/ColonyGame/Main';

interface ColonyGameProps extends PageProps<{}> {
    onComplete?: () => void;

}

class ColonyGame extends React.Component<ColonyGameProps> {
    constructor(props: ColonyGameProps) {
        super(props);
        bindAllOfThis(this, ColonyGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserColonyGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default ColonyGame;



// WEBPACK FOOTER //
// ./src/pages/game/ColonyGame.tsx